export default __webpack_public_path__ + "media/50-Plus.211d894e.svg";